<div class="block--content block" id="main-content">
    <div class="block--wrap block">
        <rwidget-alert></rwidget-alert>

        <div class="ticket">
            <aside class="block__left-side-panel">
                <div class="text-items" *ngIf="!isNewCompany">
                    <h1>
                        {{ 'EDIT_COMPANY_PROFILE' | translate }}
                    </h1>
                    <p class="text-items__description">
                        {{ 'COMPANY_ACCOUNT_INFO' | translate }}
                    </p>
                </div>
                <div class="text-items" *ngIf="isNewCompany">
                    <p class="text-items__title">
                        {{ 'ADD_COMPANY_PROFILE' | translate }}
                    </p>
                    <p class="text-items__description">
                        {{ 'ADD_COMPANY_ACCOUNT_INFO' | translate }}
                    </p>
                </div>
            </aside>

            <div class="block__right-side-panel">
                <div class="block-full-width no-padding no-border-radius">
                    <div class="edit-profile-account">
                        <div class="edit-profile-account-items-area">
                            <h2 class="edit-profile-account-items-area__title">
                                {{ 'COMPANY_DETAILS' | translate }}
                            </h2>

                            <form [formGroup]="companyForm" (ngSubmit)="submitCompany()" ridangoFocusInvalidInput>
                                <div class="edit-profile-account-items-area__item">
                                    <ridango-form-field class="form-margin-10">
                                        <input ridangoInput formControlName="name" type="text" required />
                                        <ridango-label>{{ 'MY_PROFILE_COMPANY_NAME' | translate }}</ridango-label>
                                    </ridango-form-field>
                                </div>

                                <div class="edit-profile-account-items-area__item">
                                    <ridango-form-field class="form-margin-10">
                                        <input ridangoInput formControlName="registryNumber" type="text" required />
                                        <ridango-label>{{ 'MY_PROFILE_COMPANY_REG_NO' | translate }}</ridango-label>
                                    </ridango-form-field>
                                </div>

                                <div class="edit-profile-account-items-area__item">
                                    <ridango-form-field class="form-margin-10">
                                        <input ridangoInput formControlName="vatNumber" type="text" />
                                        <ridango-label>{{ 'MY_PROFILE_COMPANY_VAT_NO' | translate }}</ridango-label>
                                    </ridango-form-field>
                                </div>

                                <div class="edit-profile-account-items-area__item">
                                    <ridango-form-field class="form-margin-10">
                                        <input ridangoInput formControlName="address" type="text" required />
                                        <ridango-label>{{ 'MY_PROFILE_COMPANY_ADDRESS' | translate }}</ridango-label>
                                    </ridango-form-field>
                                </div>

                                <div class="edit-profile-account-items-area__item">
                                    <ridango-form-field class="form-margin-10">
                                        <input ridangoInput formControlName="city" type="text" required />
                                        <ridango-label>{{ 'MY_PROFILE_COMPANY_CITY' | translate }}</ridango-label>
                                    </ridango-form-field>
                                </div>

                                <div class="edit-profile-account-items-area__item">
                                    <ridango-form-field class="form-margin-10">
                                        <input ridangoInput formControlName="postalCode" type="text" required />
                                        <ridango-label>{{
                                            'MY_PROFILE_COMPANY_POSTAL_CODE' | translate
                                        }}</ridango-label>
                                        <ridango-error
                                            *ngIf="
                                                companyForm.controls.postalCode.touched &&
                                                companyForm.controls.postalCode.hasError('pattern')
                                            ">
                                            {{ 'LOCAL_INPUT_VALIDATION_PATTERN' | translate }}</ridango-error
                                        >
                                    </ridango-form-field>
                                </div>

                                <div class="edit-profile-account-items-area__item">
                                    <ridango-form-field class="form-margin-10">
                                        <input ridangoInput formControlName="contactName" type="text" required />
                                        <ridango-label>{{
                                            'MY_PROFILE_COMPANY_CONTACT_NAME' | translate
                                        }}</ridango-label>
                                    </ridango-form-field>
                                </div>

                                <div class="edit-profile-account-items-area__item">
                                    <ridango-form-field class="form-margin-10">
                                        <input ridangoInput formControlName="contactEmail" type="email" required />
                                        <ridango-label>{{
                                            'MY_PROFILE_COMPANY_CONTACT_EMAIL' | translate
                                        }}</ridango-label>
                                    </ridango-form-field>
                                </div>

                                <div class="edit-profile-account-items-area__item">
                                    <ridango-form-field class="form-margin-10">
                                        <input ridangoInput formControlName="contactPhone" type="tel" required />
                                        <ridango-label>{{
                                            'MY_PROFILE_COMPANY_CONTACT_PHONE' | translate
                                        }}</ridango-label>
                                        <ridango-error
                                            *ngIf="
                                                companyForm.controls.contactPhone.touched &&
                                                companyForm.controls.contactPhone.hasError('minlength')
                                            ">
                                            {{ 'LOCAL_INPUT_VALIDATION_MIN_LENGTH' | translate }}</ridango-error
                                        >
                                        <ridango-error
                                            *ngIf="
                                                companyForm.controls.contactPhone.touched &&
                                                companyForm.controls.contactPhone.hasError('pattern')
                                            ">
                                            {{ 'LOCAL_INPUT_VALIDATION_PHONE_PATTERN' | translate }}</ridango-error
                                        >
                                    </ridango-form-field>
                                </div>

                                <div class="edit-profile-account-items-area__footer">
                                    <div class="edit-profile-account-items-area__right">
                                        <button class="btn btn--maximal btn--primary btn--big" type="submit">
                                            {{ 'SAVE_COMPANY_DETAILS' | translate }}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
